import { switchLocation } from '~/helpers/practiceLocation'

export default async function ({  route, store, app}) {
  if (route?.query?.switchPl) {
    const { switchPl, ...rest } = route.query
    app.router.replace({ path: route.path, query: rest })
    await switchLocation(switchPl, app.router, store )
  }
}
